import * as React from "react";
import { RootDispatch, RootState } from "../types";
import { connect } from "react-redux";
import { useEmbedTheme, SESSION_USE_EMBEDDED_THEME } from "../session/actions";
import history from "../../history";

interface StoreProps {
  isEmbeddedSession: boolean;
}

interface DispatchProps {
  triggerEmbeddedBehavior: () => void;
}

type Props = StoreProps & DispatchProps;

class TmiqMobileLandingPageComponent extends React.PureComponent<Props> {
  public constructor(props: Props) {
    super(props);
  }

  public componentDidMount() {
    window.sessionStorage.setItem(SESSION_USE_EMBEDDED_THEME, "true");
    if (!this.props.isEmbeddedSession) {
      this.props.triggerEmbeddedBehavior();
      history.replace(`/dashboard/`);
    }
  }

  public render() {
    return null;
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    isEmbeddedSession: state.session.data.isEmbeddedSession
  }),
  (dispatch: RootDispatch) => {
    return {
      triggerEmbeddedBehavior: () => {
        dispatch(useEmbedTheme());
      }
    };
  }
)(TmiqMobileLandingPageComponent);
